<template>
  <el-row :class="{'card-item':true,'active-text':active}"
          @click.native="getActive">
    <div class="label">
      <div class="label">
        {{label}}
        <el-tooltip class="item"
                    effect="dark"
                    :content="tips"
                    placement="right">
          <i class="el-icon-question icon"></i>
        </el-tooltip>

      </div>
      <div :class="{'value':true,'active-text':active}">
        {{value}}
      </div>
    </div>
  </el-row>
</template>
<script>
export default {
  props: {
    label: {
      required: true,
    },
    value: {
      required: true
    },
    tips: {
      required: false
    },
    active: {
      default: () => false
    }
  },
  methods: {
    getActive () {
      this.$emit('change', this.value)
    }
  }
}
</script>
<style lang="scss" scoped>
.card-item {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #666666;
  height: 20%;
  cursor: pointer;
  padding-left: 20px;
  border-right: 2px solid #e8e8e8;
  border-radius: 2px;
  & + & {
    margin-top: 10px;
  }
  .icon {
    font-size: 14px;
    cursor: pointer;
  }
  .value {
    font-size: 24px;
    color: #333;
    font-weight: bolder;
    margin-top: 10px;
  }
}

.active-text {
  color: #3da1ff !important;
  border-right-color: #409eff;
}
</style>
